import { mapGetters, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import CurrentUser from '../orm/models/CurrentUser';
import STORE from '../store/STORE';
import Alert from '../orm/models/Alert';
import { CONST } from '@/utils';

const { ITEM_STATUS } = CONST;

const { mutations, getters } = STORE;

Vue.mixin({
  data: function() {
    return {
      ITEM_STATUS,
      SCALE: [
        {
          name: 'SMALL',
          color: 'success',
        },
        {
          name: 'MEDIUM',
          color: 'warning',
        },
        {
          name: 'BIG',
          color: 'error',
        },
        {
          name: 'LAB',
          color: 'violet',
        },
        {
          name: 'MIX',
          color: 'blue'
        },
      ],
    };
  },
  async beforeRouteUpdate(to, from, next) {
    const { asyncData } = this.$options;
    if (this.edit) this.edit = false;
    if (asyncData) {
      try {
        await asyncData({
          store: this.$store,
          route: to,
        });
        next();
      } catch (error) {
        await Alert.create({
          data: {
            message: error,
            error: true,
          },
        });
        next();
      }
    } else {
      next();
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.edit) {
      await Alert.create({
        data: {
          message: 'You have not saved changes! Leave page?',
          button_ok_text: 'Leave',
          button_cancel_text: 'Cancel',
        },
      });
      // TODO: FIX IT
      const check = async () => {
        const alert = Alert.query().first();
        if (!alert) return;

        if (alert.agree) {
          await Alert.deleteAll();
          next();
        } else {
          setTimeout(check, 0);
        }
      };
      setTimeout(check, 0);
    } else {
      next();
    }
  },
  methods: {
    ...mapMutations({
      setCurrentGroup: `${ mutations.setCurrentGroup }`,
      setRouteLoadingValue: `${ mutations.setRouteLoadingValue }`,
    }),
    statusColor(status) {
      const statusItem = this.ITEM_STATUS.find(s => s.name === status);
      return statusItem ? statusItem.color : '';
    },
  },
  computed: {
    ...mapGetters({
      canBooking: `${ getters.canBooking }`,
      canTrial: `${ getters.canTrial }`,
    }),
    ...mapState({
      allRoutes: state => state.routes,
    }),
    currentGroup: {
      get() {
        return this.$store.state.currentGroup;
      },
      set(obj) {
        this.setCurrentGroup(obj);
        if (this.$route.meta.allowedGroups) {
          if (!this.$route.meta.allowedGroups.includes(obj.slug)) {
            this.$router.replace('/');
          }
        }
      },
    },
    currentUser() {
      return CurrentUser.query().first();
    },
    userGroups() {
      const { groups } = CurrentUser.query().first() || { groups: [] };
      return groups;
    },
    isAuthorized() {
      return !!CurrentUser.query().first();
    },
    canSetResults() {
      const permissions = this.permissions;
      return (action) => {
        return permissions
          ? permissions[action.toUpperCase()]
          : false;
      };
    },
  },
});
